<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="javascript:void()" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/nhai.png" width="60" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/nhai.png" width="100" />
            </span>
          </a>
        </div>

        <div class="d-flex">
          <h4 class="nav-header-title">PRAHARI</h4>
          <span class="nav-header-sub-title">v.1.0</span>
        </div>
        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
          v-show="currentUser.user.role !== 'rpo'"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>
      <div class="d-flex">
        <div
          right
          variant="black"
          class="header-item"
          style="margin-right: 20px"
        >
          <router-link to="/tablet/raise-incident">
            <button class="btn btn-primary mt-3">
              <i class="mdi mdi-plus mr-2"></i> RAISE NEW INCIDENT
            </button>
          </router-link>
        </div>

        <b-dropdown
          variant="white"
          right
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
          style="margin-right: 20px"
        >
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: current_language === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <!-- User -->
        <div
          right
          variant="black"
          class="header-item logout-btn"
          style="margin-right: 10px"
        >
          <a href="/phone/logout" class="dropdown-item text-warning">
            <i
              class="
                bx bx-power-off
                font-size-22
                align-middle
                mt-4
                text-warning
              "
            ></i>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import i18n from "../i18n";
import { authComputed } from "@/state/helpers";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/india.jpg"),
          language: "hi",
          title: "Hindi",
        },
      ],
      current_language: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
    };
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    if (!this.currentUser) {
      this.$router.push("/phone/logout");
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
  },
  computed: {
    ...authComputed,
    getHomeLink() {
      return this.currentUser.user.role === "rpo" ? "/rpo/dashboard" : "/";
    },
    currentUser() {
      return this.$store.getters["auth/user"];
    },
  },
};
</script>
<style>
.nav-header-title {
  margin: 28px 10px 10px 20px;
  color: rgb(182, 182, 182);
}

.nav-header-sub-title {
  margin: 32px 30px 10px 0px;
  color: rgb(129, 129, 129);
}

.logout-btn {
  border-radius: 34px;
  background: #222736;
  box-shadow: 5px 5px 10px #1a1d29, -5px -5px 10px #2b3144;
}
</style>